import { Link } from "react-router-dom";
import { LogoFull } from "@/components/Logo";

const COLS = [
  {
    title: "Company",
    links: [
      { label: "Company Overview", to: "/company" },
      { label: "Careers", to: "/careers" },
      { label: "Investor Relations", to: "/investors" },
      { label: "Contact", to: "/contact" },
    ],
  },
  {
    title: "Contact",
    links: [
      { label: "info@truelifeentertainment.com", href: "mailto:info@truelifeentertainment.com" },
      { label: "hello@truelifeentertainment.com", href: "mailto:hello@truelifeentertainment.com" },
      { label: "www.truelifeentertainment.com", href: "https://www.truelifeentertainment.com" },
    ],
  },
];

const Footer = () => (
  <footer data-testid="footer" className="border-t border-white/10 bg-charcoal-900 text-white">
    <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8 lg:py-20">
      <div className="grid grid-cols-1 gap-12 md:grid-cols-12">
        <div className="md:col-span-6">
          <LogoFull dark />
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-slate-400">
            A technology company and an entertainment company, and the bridge between the two.
            Home of LANTIX and LANTIX PRO.
          </p>
          <p className="mt-6 font-mono text-[11px] uppercase tracking-[0.2em] text-slate-500">
            Boston, Massachusetts
          </p>
        </div>
        {COLS.map((col) => (
          <div key={col.title} className="md:col-span-3">
            <h3 className="font-mono text-[11px] font-semibold uppercase tracking-[0.25em] text-slate-500">{col.title}</h3>
            <ul className="mt-5 space-y-3">
              {col.links.map((l) => (
                <li key={l.label}>
                  {l.to ? (
                    <Link
                      to={l.to}
                      data-testid={`footer-link-${l.to.replace("/", "") || "home"}`}
                      className="text-sm text-slate-300 transition-colors hover:text-white"
                    >
                      {l.label}
                    </Link>
                  ) : (
                    <a href={l.href} data-testid={`footer-link-${l.label.split("@")[0]}`} className="break-all text-sm text-slate-300 transition-colors hover:text-white">
                      {l.label}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="mt-14 flex flex-col justify-between gap-4 border-t border-white/10 pt-8 font-mono text-[11px] uppercase tracking-[0.15em] text-slate-500 sm:flex-row">
        <span data-testid="footer-copyright">© 2026 True Life Entertainment Inc.</span>
        <span>Technology and entertainment company</span>
      </div>
    </div>
  </footer>
);

export default Footer;
